import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { enumEntrySummaryState } from '@data-layer/enums/entry-summaries';
import { EntrySummaryModel } from '@data-layer/models/entry-summaries';
import { IS_CREATING_ES_INVOICE_KEY, IS_CREATING_ES_KEY } from '@shared/es-mutual/const';

@Injectable({ providedIn: 'root' })
export class EsStepsService {
  private creatingBL: boolean;

  constructor(private activeRoute: ActivatedRoute, private router: Router) {}

  public get isOnSummary(): boolean {
    return !this.isCreating && !this.isCreatingInvoice;
  }

  public get isCreating(): boolean {
    return !!this.activeRoute.snapshot.queryParams[IS_CREATING_ES_KEY];
  }

  public get isCreatingBL(): boolean {
    return this.creatingBL;
  }

  public set isCreatingBL(value: boolean) {
    this.creatingBL = value;
  }

  public get isCreatingInvoice(): boolean {
    return !!this.activeRoute.snapshot.queryParams[IS_CREATING_ES_INVOICE_KEY];
  }

  public get creatingInvoiceBLId(): number {
    return Number(this.activeRoute.snapshot.queryParams[IS_CREATING_ES_INVOICE_KEY]);
  }

  public isStepLocked(entrySummary: EntrySummaryModel): boolean {
    return [
      enumEntrySummaryState.SENT_TO_PROVIDER,
      enumEntrySummaryState.VALIDATED_AT_PROVIDER,
      enumEntrySummaryState.PROVIDER_SEND_PENDING,
      enumEntrySummaryState.BROKER_PROCESSING_PENDING,
    ].includes(entrySummary?.state);
  }

  public redirectESToSummary(referenceNumber: string): void {
    this.router.navigate(['entry-summary', referenceNumber, 'summary']);
  }

  public checkAndRedirectESToSummary(entrySummary: EntrySummaryModel): void {
    if (this.isStepLocked(entrySummary)) {
      this.redirectESToSummary(entrySummary.referenceNumber);
    }
  }
}
